// extracted by mini-css-extract-plugin
export default {"FPhoneInput":"FPhoneInput___bRuXM","select":"select___gcT6E","input":"input___vn013"};